
interface LocalStorageState {
    game: {
        myIdByGameId: { [gameId: string]: string }
    }
}

function  mergeStates(
    newState: LocalStorageState, 
    oldState: LocalStorageState|undefined
): LocalStorageState {
    return {
        game: {
            myIdByGameId: {
                ...oldState?.game.myIdByGameId,
                ...newState.game.myIdByGameId,
            },
        },
    }
}

export function loadState(): LocalStorageState|undefined {
    try {
        const serializedState = localStorage.getItem('state')
        if (serializedState === null) {
            return undefined
        }
        return JSON.parse(serializedState)
    } catch (_) {
        return undefined
    }
}

export function saveState(state: LocalStorageState) {
    const oldState = loadState()
    const newState = mergeStates(state, oldState)
    const serializedState = JSON.stringify(newState)
    try {
        localStorage.setItem('state', serializedState)
    } catch (e) {
        // ignore errors    
    }
}